/* eslint-disable camelcase */
import { BaseModel } from '~/shared/model'

export class WorkCardModel extends BaseModel {
  id: string = ''
  name: string = ''
  number: number = 0
  description: string = ''
  image: string = ''
  href: string = ''
}

export interface WorkCardModelList {
  status_code: number
  message: string
  data: WorkCardModel[]
}
